import HBButton from "@/components/HBButton";
import HBIcon from "@/components/HBIcon";
import Image from "@/components/Image";
import imageUrl from "@/utils/imageUrl";
import classNames from "classnames";
import { Else, If, Then, When } from "react-if";
import styles from "./index.module.less";

const iconMap = {
  time: "采集至画板",
  search: "",
};

interface IProps {
  board: (IBoardInfo & { _icon?: string }) | null;
  cover?: IPinFile & { is_private?: number };
  index?: number;
  activeIndex?: number;
  onSelect?: (boardId: number) => void;
  isRecommended?: boolean;
  isRelatedBoard?: boolean;
  onUserBoardUpdate?: (board: any) => void;
  searchWord?: string;
  isOnlyUnclassified?: boolean;
  renderActions?: (board: IBoardInfo) => React.ReactNode;
  hoverShowActions?: boolean;
}
export default function BoardItem({
  board,
  cover,
  index,
  activeIndex,
  onSelect,
  isRecommended = false,
  isRelatedBoard = false,
  onUserBoardUpdate,
  searchWord,
  isOnlyUnclassified = false,
  renderActions,
  hoverShowActions,
}: IProps) {
  return (
    <>
      {isOnlyUnclassified ? (
        <div className={styles.splitText}>先采集后整理</div>
      ) : (
        board?._icon && (
          <div className={styles.splitText}>
            {iconMap[board._icon] || board._icon}{" "}
          </div>
        )
      )}
      <div
        className={classNames([
          styles.item,
          activeIndex === index ? styles.active : null,
          hoverShowActions ? styles.hoverShowActions : null,
        ])}
        data-board-id={board?.board_id}
        data-gd-click="button_click"
        data-button-name={isRelatedBoard ? "确定创建画板" : "确认采集"}
        onClick={async () => {
          if (isRelatedBoard && onUserBoardUpdate) {
            // 如果是推荐的同在画板，需要先创建画板
            const boardName = board?.title || "";
            if (boardName) {
              try {
                // 动态导入创建画板API
                const { createBoard } = await import("@/services");

                // console.log("开始创建并采集到推荐画板:", boardName);

                // 1. 创建画板
                const createResult = await createBoard({
                  title: boardName,
                });

                if (createResult.err) {
                  console.error("创建画板失败:", createResult.msg);
                  return;
                }

                // 2. 更新用户画板列表
                onUserBoardUpdate(createResult.board);

                // 3. 触发采集到新创建的画板
                onSelect(createResult.board.board_id);
              } catch (error) {
                console.error("创建并采集推荐画板失败:", error);
              }
            }
          } else {
            onSelect(board?.board_id);
          }
        }}
        data-search-word={searchWord}
        data-pin-detail
        data-index={index}
      >
        <div className={styles.content}>
          <div className={styles.left}>
            <div className={styles.img}>
              <If condition={!!cover}>
                <Then>
                  <Image
                    src={imageUrl(cover, { width: 32 })}
                    alt={board?.title}
                  />
                </Then>
                <Else>
                  <div className={styles.cover}>
                    <HBIcon type="ic_logo" />
                  </div>
                </Else>
              </If>
            </div>
            <div className={styles.name}>
              {board ? board?.title : "未整理的采集"}
            </div>
            <When
              condition={
                board?.is_private &&
                board?.is_private !== 0 &&
                board?.is_private !== 1
              }
            >
              <HBIcon
                type="lock"
                className={styles.boardIcon}
                title="私有画板"
              />
            </When>

            <When condition={board?.extra?.collab}>
              <HBIcon
                type="duoren"
                className={styles.boardIcon}
                title="多人协作画板"
                style={{ marginTop: 1, fontSize: 17 }}
              />
            </When>
          </div>
        </div>
        <div className={styles.operation}>
          <HBButton
            type="primary"
            data-board-id={board?.board_id}
            data-gd-click="button_click"
            data-button-name={isRelatedBoard ? "确定创建画板" : "确认采集"}
            data-search-word={searchWord}
            data-pin-detail
            size="small"
          >
            {isRelatedBoard ? "创建并采集" : "采集"}
          </HBButton>
        </div>
      </div>
    </>
  );
}
